import { ref, onMounted } from 'vue'
import { request } from '@/utils/request'
import { arrayToMap } from '@/utils/index'

export default function () {
  const skillsList = ref([])
  const endToolList = ref([])
  const endToolMap = ref({})

  const getActivityType = async () => {
    try {
      const res = await request('getDictData', {
        dictType: 'embodySkill'
      })
      skillsList.value = res || []
    } catch (error) {
      console.error(error)
    }
  }
  const getEndtools = async () => {
    try {
      const res = await request('getDictData', {
        dictType: 'endTool'
      })
      endToolList.value = res || []
      endToolMap.value = arrayToMap(endToolList.value, 'dictCode', 'dictLabel')
    } catch (error) {
      console.error(error)
    }
  }

  onMounted(() => {
    getActivityType()
    getEndtools()
  })

  return {
    skillsList,
    endToolList,
    endToolMap
  }
}
